<template>
	<div class="supervisorRightPages" ref="containerPie">
		<div v-if="isRightPie.pie">
			<div class="supervisorRightBorder">
				<div class="titleNew">
					<svg-icon class="fz18 marr5" icon-class='icon-equipmenttype'></svg-icon><span>设备类型</span>
				</div>
				<div id='containerPie'></div>
				<div class="containerBox">
					<p class="titleP" v-for="(item,index) in Summary.ModalityTypes" :key='index'><span><em :style="{background:item.color}"></em>{{item.ModalityType}}:{{item.Count}}</span></p>
				</div>
				</div>
			<i class="supervisorRightSilder"></i>
			<div class="supervisorRightBorder">
				<div class="titleNew">
					<svg-icon class="fz18 marr5" icon-class='icon-Scanningmode'></svg-icon> <span>扫描方式</span></div>
				<div id='containerPie1'></div>
				<div class="containerBox">
					<p class="titleP" v-for="(item,index) in Summary.ScanTypes" :key='index'><span><em :style="{background:item.color}"></em>{{item.ScanType}}:{{item.Count}}</span></p>
				</div>
				</div>
			<i class="supervisorRightSilder"></i>
			<div class="supervisorRightBorder">
				<div class="titleNew">
					<svg-icon class="fz18 marr5" icon-class='icon-Inspectionpart'></svg-icon>
					<span>检查部位</span>
				</div>
				<div id='containerPie2'></div>
				<div class="containerBox">
					<p class="titleP" v-for="(item,index) in Summary.BodyParts" :key='index'><span><em :style="{background:item.color}"></em>{{item.BodyPart}}:{{item.Count}}</span></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import echarts from 'echarts';
	export default {
		data() {
			return {
				myChart:null
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['trigger', 'Summary', 'SummaryTotalReportCount', 'DoctorsAvgScoreName', 'isRightPie', 'breadcrumbList', 'slider', 'GetReportListArr', 'DoctorsAvgScoreNamejudge', 'setDateArr']),
			...Vuex.mapState('breadcrumb', ['pieColorList','skinPeeler']),
			triggers() {
				return this.trigger.numberPie;
			}
		},
		watch: {
			triggers(old) {
				if(old) {
					this.initPie();
				}
			},
			skinPeeler: {
			  handler(newValue, oldValue) {
			     this.initPie();
			  },
			  deep: true
			}
		},
		updated() {
			if(this.trigger.numberPie) {
				this.initPie();
			}
		},
		mounted() {
			let _this = this;
			this.erd.listenTo(document.getElementsByClassName("el-main"), function (element) {
			    _this.initPie();
		    })
		},
		methods: {
			...Vuex.mapMutations('breadcrumb',['setTootipType','clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond','setLoading', 'setBreadcrumbList', 'setSplitScreen']),
			...Vuex.mapActions('supervisor', ['GetReportList']),
			initPie(){
				if (this.Summary.ModalityTypes||this.Summary.ScanTypes||this.Summary.BodyParts) {
					this.trigger.numberPie = false;
					this.getEchartsPie('containerPie', this.Summary.ModalityTypes)
					this.getEchartsPie('containerPie1', this.Summary.ScanTypes)
					this.getEchartsPie('containerPie2', this.Summary.BodyParts);
				}
			},
			getEchartsPie(id, data) {
				let dom = document.getElementById(id);
				this.myChart = echarts.init(dom);
				let app = {};
				let option = null;
				let datas = [];
				let color = [];
				if(id == 'containerPie') {
					color = this.pieColorList.color1;
					data.map(res => {
						datas.push({
							name: res.ModalityType,
							value: res.Count
						})
					})
				}
				if(id == 'containerPie1') {
					color = this.pieColorList.color2;
					data.map(res => {
						datas.push({
							name: res.ScanType,
							value: res.Count
						})
					})
				}
				if(id == 'containerPie2') {
					color = this.pieColorList.color3;
					data.map(res => {
						datas.push({
							name: res.BodyPart,
							value: res.Count
						})
					})
				}
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				option = {
					color: color,
//					legend: {
//						icon: 'circle',
//						orient: 'horizontal',
//						align: 'left',
//						itemGap: 15,
//						bottom: 10,
//						left:0,
//						itemWidth: 10,
//						itemHeight: 10,
//						data: datas,
//						textStyle: {
//							color: '#ffffff',
//							fontSize: 12,
//							padding: [0, 0, 0, 8],
//							rich: {
//								a: {
//									width: 80
//								}
//							}
//						},
//						formatter: function(name) {
//							let target;
//							for(let i = 0, l = datas.length; i < l; i++) {
//								if(datas[i].name == name) {
//									target = datas[i].value;
//								}
//							}
//							let arr = [
//								name + ': ' + target
//							]
//							let arr = [
//								'{a|' + name + ': ' + target + '}',
//							]
//							return arr.join('\n')
//						}
//					},
					tooltip: {
						trigger: 'item',
						// formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					grid: {
						top: '6%',
						left: 0,
						right: 0,
						bottom: 0,
						containLabel: true
					},
					series: [{
						name: '质控数',
						type: 'pie',
						center: ['50%', '40%'],
						radius: "60%",
						minAngle: 15,//最小角度
						startAngle:180, //起始角度
						hoverOffset: 10,
						label: {
							color: changeColor,
							formatter: '{b|{b}}',
							alignTo: 'labelLine',
							rich: {
								b: {
									align: 'left',
									color: changeColor
								}
							}
						},
						labelLine: {
							lineStyle: {
								color: changeColor
							},
							length2:3
						},
						data: datas
					}]
				};;
				if(option && typeof option === "object") {
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.setLoading(true)
						this.setTootipType(false);
						this.clearRow();
						this.currentChangesSecond(1);
						this.setBreadcrumbList();
						this.breadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
						if(id == 'containerPie') {
							this.GetReportListArr.type = '设备类型';
						} else if(id == 'containerPie1') {
							this.GetReportListArr.type = '扫描方式';
						} else {
							this.GetReportListArr.type = '检查部位';
						}
						this.GetReportListArr.status = 'supervisor';
						this.breadcrumbList.push(params.name);
						this.GetReportListArr.name = params.name;
						this.breadcrumbList.push("pie");
						this.$router.push("/home/supervisor/qualifiedTable");
					});
				}
				
				this.myChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
			}
		}
	}
</script>

<style>

</style>